export default __webpack_public_path__ + "e85bb4b31b45ae3da38a2db274fac6f1.ogg";